import React, { ReactNode } from "react"
import { Menu as AntdMenu } from "antd"
import type { MenuProps } from "antd/lib/menu"

export const Menu = ({ children, ...props }: MenuProps & { children: ReactNode }): JSX.Element => {
  return <AntdMenu {...props}>{children}</AntdMenu>
}
